<template>
  <div class="retireve-password">
    <div class="wavy-line"></div>
    <!--    找回密码-->
    <div class="retireve-password-box" v-show="step === 1||step === 2">
      <div class="bg-img"></div>
      <div :class="{'box':true,'box-widen':step === 1}">
        <p style="padding: 10px 0;color: #fff" v-show="step === 1">验证登录账号和{{{1:'上游',3:'工业'}[type]}}信息</p>
        <p style="padding: 10px 0;color: #fff" v-show="step === 2">验证登录账号绑定的手机号</p>
        <!--    验证登录账号和企业信息-->
        <el-form ref="form" :model="form" :rules="rules" v-show="step === 1">
          <el-form-item label="" prop="login_account">
            <el-input v-model="form.login_account" style="width: 70%;" placeholder=" 请输入企业登录账号，如忘记请联系服务提供商！"
                      :class="{'input-widen':step === 1}"></el-input>
            <el-button type="primary" style="float: right;" @click="onSubmit('form')">确定</el-button>
          </el-form-item>
          <p style="margin-bottom:15px; ">所属{{{1:'上游',3:'工业'}[type]}}：{{company_name}}</p>
          <el-button type="primary" style="width: 100%" @click="nextStep(2)">下一步</el-button>
        </el-form>
        <!--    验证登录账号绑定的手机号-->
        <el-form ref="form2" :model="form2" :rules="rules2" v-show="step === 2">
          <el-form-item label="" prop="phone">
            <el-input v-model="form2.phone" placeholder="请输入登录账号绑定的手机号" maxlength="11"></el-input>
          </el-form-item>
          <el-form-item label="" prop="sms">
            <el-input v-model="form2.sms" style="width: 60%" placeholder="输入6位短信验证码" maxlength="6"></el-input>
            <el-button type="primary" style="float: right;width: 112px" @click="getCode" :disabled="getCodeTxt != '获取验证码'">{{getCodeTxt}}</el-button>
          </el-form-item>
          <el-button type="primary" style="width: 100%" @click="nextStep(3)">下一步</el-button>
        </el-form>
      </div>
    </div>
    <!-- 设置新密码-->
    <div
      class="retireve-password-box retireve-password-box2"
      v-show="step === 3"
    >
      <div class="bg-img"></div>
      <div class="box">
        <el-form ref="form3" :model="form3" :rules="rules3" >
          <el-form-item label="" prop="password">
            <el-input v-model="form3.password" placeholder="新密码" show-password></el-input>
          </el-form-item>
          <el-form-item label="" prop="affirmPassword">
            <el-input v-model="form3.affirmPassword"  placeholder="再次输入新密码" show-password></el-input>
          </el-form-item>
          <el-button type="primary" style="width: 100%" @click="nextStep(4,'form3')" :loading="resetLoading">重置密码</el-button>
        </el-form>
      </div>
    </div>
    <!-- 设置成功-->
    <div
      class="retireve-password-box retireve-password-box3"
      v-show="step === 4"
    >
      <div class="bg-img"></div>
      <div class="box">
        <p
          style="text-align: center;color:#fff;font-size:14px;font-weight:400;margin-bottom: 30px;"
        >
          登录密码设置成功！
        </p>
        <el-button type="primary" style="width: 100%" @click="nextStep(5)">重新登录</el-button>
      </div>
    </div>
<!--    <div-->
<!--      class="page-footer"-->
<!--      v-bind:class="{ collapsed: $store.state.collapsed }"-->
<!--    >-->
<!--&lt;!&ndash;      Copyright &copy;{{ currentYear }} by 上海正也信息科技有限公司&ndash;&gt;-->
<!--      <a href="http://www.beian.miit.gov.cn" class="beian" target="_blank"-->
<!--      >沪ICP备14016032号-3</a-->
<!--      >-->
<!--    </div>-->
  </div>
</template>

<script>
import {
  checkCompanyCode, sendSms, checkSms, changePassword,
} from '@/api';

export default {
  name: 'RetrieveThePassword',
  beforeCreate() {
    this.type = this.$route.params.type;// 3 综合服务商端    1 项目服务商端
  },
  data() {
    const password = (rule, value, callback) => {
      const reg = new RegExp(/^[A-Za-z0-9]+$/);
      const numberReg = new RegExp(/^[0-9]+$/);
      const letterReg = new RegExp(/^[A-Za-z]+$/);
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (!reg.test(value)) {
        return callback(new Error('请输入汉字、字母'));
      } else if (numberReg.test(value) || letterReg.test(value)) {
        return callback(new Error('密码必须是数字与字母组合'));
      } else if (value.length < 6) {
        callback(new Error('密码应等于大于6位数'));
      } else {
        callback();
      }
    };
    const validateAffirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('再次输入密码'));
      } else if (value !== this.form3.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      step: 1,
      form: {
        login_account: '',
      },
      rules: {
        login_account: [
          {
            required: true,
            message: '请输入企业登录账号',
            trigger: 'blur',
          },
        ],
      },
      form2: {
        phone: '',
        sms: '',
      },
      rules2: {
        phone: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur',
          },
        ],
        sms: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'blur',
          },
        ],
      },
      form3: {
        password: '',
        affirmPassword: '',
      },
      rules3: {
        password: [
          {
            validator: password,
            required: true,
            message: '',
            trigger: 'blur',
          },
        ],
        affirmPassword: [
          {
            validator: validateAffirmPassword, trigger: 'blur', required: true, message: '',
          },
        ],
      },
      company_id: null,
      company_name: '',
      getCodeTxt: '获取验证码',
      isCount: 60,
      isSend: true,
      resetLoading: false,
    };
  },
  methods: {
    onSubmit(formName) {
      if (formName == 'form') {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const formValues = { ...this.form };
            let is_int_server = 1;
            if (this.type == 1) {
              is_int_server = '0';
            }
            checkCompanyCode(formValues.login_account, is_int_server).then((res) => {
              if (res.status === 0) {
                this.company_id = res.data.company_id;
                this.company_name = res.data.company_name;
              } else {
                this.$message.error('登录账号不存在！');
              }
            });
          }
        });
      }
    },
    getCode() {
      const formValues = { ...this.form2 };
      const data = {
        phone: formValues.phone,
        is_server_client: 1,
        company_id: this.company_id,
      };
      if (formValues.phone == '' || !formValues.phone) {
        return;
      }
      if (this.isSend) {
        this.isSend = false;
        data.is_int_server = 1;
        if (this.type == 1) {
          data.is_int_server = '0';
        }
        sendSms(data).then((res) => {
          if (res.status === 0) {
            this.countDown();
          } else {
            this.isSend = true;
            this.$message.error(res.msg);
          }
        });
      }
    },
    countDown() {
      const that = this;
      this.timer = setInterval(() => {
        if (that.isCount != 0) {
          that.getCodeTxt = `${that.isCount}S`;
          that.isCount--;
        } else {
          clearInterval(that.timer);
          that.isCount = 60;
          that.getCodeTxt = '获取验证码';
          this.isSend = true;
        }
      }, 1000);
    },
    nextStep(type, formName) {
      if (type == 2) {
        if (this.company_name == '') {
          this.$message.error('请输入企业登录账号');
          return;
        }
        this.step = type;
      } else if (type == 3) {
        const formValues = { ...this.form2 };
        if (formValues.phone != '' && formValues.sms != '') {
          let is_int_server = 1;
          if (this.type == 1) {
            is_int_server = '0';
          }
          checkSms(formValues.phone, formValues.sms, is_int_server).then((res) => {
            if (res.status === 0) {
              this.step = type;
            } else {
              this.$message.error(res.msg);
            }
          });
        } else if (formValues.phone == '') {
          this.$message.error('请输入手机号');
        } else if (formValues.sms == '') {
          this.$message.error('请输入验证码');
        }
      } else if (type == 4) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const formValues = { ...this.form3 };
            formValues.company_id = this.company_id;
            formValues.login_account = this.form.login_account;
            delete formValues.affirmPassword;
            formValues.is_int_server = 1;
            if (this.type == 1) {
              formValues.is_int_server = 0;
            }
            this.resetLoading = true;
            changePassword(formValues).then((res) => {
              if (res.status === 0) {
                this.step = type;
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        });
      } else if (type == 5) {
        this.$router.push({ name: 'login', params: {} });
      }
    },
  },
};
</script>

<style scoped lang="scss">
  .retireve-password {
    position: relative;
    width: 100%;
    height: 100%;
    background: url('~@/assets/img/login/img_background.png') repeat-x;
    background-size: auto 100%;
    .wavy-line {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 236px;
      background: url('~@/assets/img/login/img_wavy_line2.png') no-repeat;
      background-size: 100% 100%;
    }
  }
  .retireve-password-box {
    position: absolute;
    top: 80px;
    left: 50%;
    transform: translate(-50%, 0);
    width: 1000px;
    .bg-img {
      width: 100%;
      height: 480px;
      background: url('~@/assets/img/login/img_retrieve_password.png') no-repeat;
      background-size: 100% 100%;
    }
    .box {
      position: absolute;
      left: 50%;
      top: 334px;
      transform: translate(-50%, 0);
      width: 292px;
    }
    .input-item {
      border: 0 none;
      font-size: 16px;
      outline: 0 none;
      &:focus {
        outline: none;
        border: 0 none;
        box-shadow: none;
      }
      &::placeholder {
        font-size: 13px;
      }
    }
  }
  .retireve-password-box2 {
    .bg-img {
      background: url('~@/assets/img/login/img_new_password.png') no-repeat;
      background-size: 100% 100%;
    }
  }
  .retireve-password-box3 {
    .bg-img {
      background: url('~@/assets/img/login/img_successful_setup.png') no-repeat;
      background-size: 100% 100%;
    }
    .box {
      top: 398px;
    }
    .login-form-button {
      margin-top: 40px;
    }
  }
  .page-footer {
    position: fixed;
    bottom: 5px;
    left: 0;
    width: 100%;
    text-align: center;
    height: 16px;
    color: #fff;
    font-size: 11px;
    .beian {
      color: #fff;
    }
  }
  .sms-button {
    margin-top: 1px;
    padding: 0 10px;
    font-size: 12px;
    color: #ffb932;
    width: 113px;
    &[disabled] {
      color: #ffb932;
    }
  }
  .box-widen{
    width: 428px!important;
  }
  .input-widen{
    width: 80%!important;
  }
</style>
